import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8c59569c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=8c59569c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c59569c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c59569c')) {
      api.createRecord('8c59569c', component.options)
    } else {
      api.reload('8c59569c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8c59569c&scoped=true&", function () {
      api.rerender('8c59569c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21vwooRuNf4EY/JS/comp/SearchFilterTokens.vue"
export default component.exports